var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckedGreen({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.828851 9.75267C1.95023 11.7601 4.09598 13.1175 6.55877 13.1175C10.1811 13.1175 13.1175 10.1811 13.1175 6.55877C13.1175 2.93646 10.1811 0 6.55877 0C2.93646 0 0 2.93646 0 6.55877C0 7.71829 0.30089 8.80753 0.828851 9.75267Z",
    fill: "#00AB65"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.64355 6.8304L5.37361 8.55973L8.83227 5.10107",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedGreen);
export default __webpack_public_path__ + "static/media/CheckedGreen.3a868a2bb57c118fa4f83e8933f4231b.svg";
export { ForwardRef as ReactComponent };